var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BlBackdrop", { attrs: { footer: false } }, [
        _c("div", { style: { height: "95vh", width: "97.5vw" } }, [
          _c(
            "div",
            {
              staticClass:
                "h-30 pt-10 px-10 flex items-start justify-between gap-4 flex-shrink-0"
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-2 truncate",
                  attrs: { title: _vm.document.filename }
                },
                [
                  _c("BlTextTitle4", {
                    staticClass: "truncate",
                    attrs: { text: _vm.document.filename }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", { attrs: { text: "Uploaded on" } }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text: _vm.displayDate({
                            date: _vm.document.created_at
                          })
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "by" } }),
                      _vm._v(" "),
                      !_vm.document.user
                        ? _c("BlTextBody2", {
                            staticClass: "italic",
                            attrs: { text: "Deleted user" }
                          })
                        : _c("BlTextBody2", {
                            attrs: { text: _vm.document.user.name }
                          })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-2 flex-shrink-0" },
                [
                  _c("BlInputButton", {
                    attrs: { label: "Delete", type: "outlined-error" },
                    on: {
                      clicked: function($event) {
                        _vm.deleteOpened = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { label: "Download", loading: _vm.downloadLoading },
                    on: { clicked: _vm.onDownload }
                  }),
                  _vm._v(" "),
                  _c("BlIcon", {
                    staticClass: "h-6 w-6",
                    attrs: { icon: "close", clickable: "" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("close-modal")
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-full px-10 bg-slate-300 rounded-b-3xl",
              style: { height: "calc(95vh - 7.5rem)" }
            },
            [
              _vm.contentType.includes("image")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "h-full w-full pt-5 pb-10 flex items-center justify-center"
                    },
                    [
                      _c("img", {
                        staticClass: "h-full w-auto",
                        attrs: {
                          src: _vm.document.file_url,
                          alt: _vm.document.filename
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.contentType.includes("pdf")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "relative h-full w-full flex items-center justify-center overflow-hidden"
                    },
                    [
                      _c("iframe", {
                        staticClass:
                          "absolute inset-0 h-full w-full object-cover",
                        attrs: {
                          title: _vm.document.filename,
                          src: _vm.document.file_url
                        }
                      })
                    ]
                  )
                : _vm._e()
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete file",
              label: "Delete file",
              description:
                "<div class='break-words'>You are about to delete <b>" +
                _vm.document.filename +
                "</b> from your client. Are you sure you want to proceed? This action cannot be undone.</div>",
              type: "error",
              submitLoading: _vm.deleteLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onDelete
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6990dcf1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6990dcf1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/file/PreviewModal.vue
// module id = null
// module chunks = 